// Canonical event status labels. Keep in sync with
// fair-fest-server/src/modules/events/event-status.service.ts → EventStatusService.label()
export const EVENT_STATUS_LIST = [
    { status: 'DRAFT',                label: 'Draft',                short: 'Draft',      tagColor: 'default', dot: '#9CA3AF' },
    { status: 'REGISTRATION_OPEN',    label: 'Registration Open',    short: 'Reg. Open',  tagColor: 'success', dot: '#10B981' },
    { status: 'REGISTRATION_CLOSED',  label: 'Registration Closed',  short: 'Reg. Closed',tagColor: 'warning', dot: '#F59E0B' },
    { status: 'ONGOING',              label: 'Event Started',        short: 'Started',    tagColor: 'blue',    dot: '#3B82F6' },
    { status: 'JUDGING',              label: 'Scoring in Progress',  short: 'Scoring',    tagColor: 'purple',  dot: '#8B5CF6' },
    { status: 'RESULT_UNPUBLISHED',   label: 'Results Ready',        short: 'Ready',      tagColor: 'gold',    dot: '#D97706' },
    { status: 'RESULT_PUBLISHED',     label: 'Results Published',    short: 'Published',  tagColor: 'cyan',    dot: '#06B6D4' },
    { status: 'COMPLETED',            label: 'Completed',            short: 'Completed',  tagColor: 'green',   dot: '#059669' },
    { status: 'LOCKED',               label: 'Locked',               short: 'Locked',     tagColor: 'red',     dot: '#EF4444' },
    { status: 'CANCELLED',            label: 'Cancelled',            short: 'Cancelled',  tagColor: 'default', dot: '#6B7280' },
] as const;

export const EVENT_STATUS_TAG_COLOR: Record<string, string> = Object.fromEntries(
    EVENT_STATUS_LIST.map(s => [s.status, s.tagColor])
);

export const EVENT_STATUS_LABEL: Record<string, string> = Object.fromEntries(
    EVENT_STATUS_LIST.map(s => [s.status, s.label])
);

export const EVENT_STATUS_SHORT_LABEL: Record<string, string> = Object.fromEntries(
    EVENT_STATUS_LIST.map(s => [s.status, s.short])
);

export function getEventStatusTagColor(status: string): string {
    return EVENT_STATUS_TAG_COLOR[status] || 'default';
}

export function getEventStatusLabel(status: string): string {
    return EVENT_STATUS_LABEL[status] || status;
}

export function getEventStatusShortLabel(status: string): string {
    return EVENT_STATUS_SHORT_LABEL[status] || status;
}
